<!-- examProcessManag 考试过程管理 -->
<template>
  <div class="processManag">
    <div v-show="activeMenu === 'processManag'">
      <el-tabs v-model="activeName">
        <el-tab-pane label="线上考试" name="onLine">
          <onLineExam @goTo="goTo" />
        </el-tab-pane>
        <el-tab-pane label="理论考试" name="theory">
          <theoryTest @goToTheoryTest="goToTheoryTest" />
        </el-tab-pane>
        <el-tab-pane label="线下考试" name="offLine">
          <offLineExam @goToOffInfo="goToOffInfo" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <router-view v-show="activeMenu != 'processManag'" />
  </div>
</template>

<script>
import onLineExam from "./onLineExam";
import offLineExam from "./offLineExam";
import theoryTest from "./theoryTest";
export default {
  components: {
    onLineExam,
    offLineExam,
    theoryTest
  },
  mounted() { },
  methods: {
    goTo(name, row) {
      this.$router.push({
        path: "/examManag/processManag/examInfo",
        query: {
          id: row.examId,
          name: row.subjectName,
          notSubmitNum: row.notSubmitNum,
          queryState: row.queryState,
        },
      });
    },
    goToTheoryTest(row) {
      console.log(999, row);
      this.$router.push({
        path: "/examManag/processManag/theoryInfo",
        query: {
          id: row.examId,
          name: row.subjectName,
          notSubmitNum: row.notSubmitNum,
          queryState: row.queryState,
          row: JSON.stringify(row)
        },
      });
    },
    goToOffInfo(row) {
      this.$router.push({
        path: "/examManag/processManag/offExamInfo",
        query: {
          id: row.examId,
          name: row.subjectName,
          notExamNum: row.notExamNum,
          queryState: row.queryState,
        },
      });
    },
  },
  data() {
    return {
      activeName: "onLine",
      showIdNumber: false,
      showPhone: false,
      showScore: false,
    };
  },
  computed: {
    activeMenu() {
      return this.$route.name;
    },
  },
};
</script>

